module.exports = __webpack_public_path__ + "static/media/arrow.9e60c0cd.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Bubble/arrow.svg
 ** module id = 118
 ** module chunks = 0
 **/